// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a6k0","index":"styles_index__1AgrJ"};